import { StatusTable } from "./components/StatusTable"
import { AlertMessages } from "./components/AlertMessages"
import { OilList, ZIC_OILS } from "./components/OilList"
import styles from "./HowToWork.module.scss"
import clsx from "clsx"

export function Block(props) {
    switch (props.type) {
        case "p":
            return <p className={props.className}>{props.children}</p>

        case "image": {
            const img = (
                <img
                    className={styles.image}
                    src={props.src}
                    alt={props.alt}
                    width={props.width}
                    loading={props.lazy ? "lazy" : undefined}
                />
            )

            if (!props.mobileSrc) return img

            return (
                <picture>
                    <source media="(max-width: 767px)" srcSet={props.mobileSrc} />
                    {img}
                </picture>
            )
        }

        case "alert":
            return <AlertMessages>{props.children}</AlertMessages>

        case "oils":
            return (
                <AlertMessages>
                    <p>Модели масел ZIC, которые участвуют в программе:</p>
                    <br />
                    <OilList items={props.items ?? ZIC_OILS} />
                </AlertMessages>
            )

        case "table":
            return <StatusTable rows={props.rows} />

        case "subtitle":
            return (
                <div id={props.id} className={styles.subTitle}>
                    <span className={styles.subNumber} aria-hidden="true">
                        {props.number}
                    </span>
                    <h3>{props.children}</h3>
                </div>
            )

        case "list":
            return (
                <ul className={styles.bulletList}>
                    {props.items.map((it, i) => (
                        <li key={i}>{it}</li>
                    ))}
                </ul>
            )

        case "feedbackLink":
            return (
                <a className={clsx(styles.linkBorder, styles.textSemibold, styles.feedbackLink)} href="/feedback">
                    https://zictop.ru/feedback
                </a>
            )

        default:
            return null
    }
}
